<template>
  <vue-easy-lightbox :visible="visible" :imgs="images" :index="index" teleport="body" loop move-disabled @hide="$emit('hide')" />
</template>
<script setup lang="ts">
import VueEasyLightbox from 'vue-easy-lightbox'

defineProps({
  images: {
    type: Array,
    required: true,
  },
  index: {
    type: Number,
    required: true,
    default: 0,
  },
  visible: {
    type: Boolean,
    required: true,
  },
})
defineEmits(['hide'])
</script>
